import {FC, ReactNode} from 'react';
import * as css from './SelectPopup.css';

interface AddAction {
    text: string;
    emptyText?: string;
    onClick: () => void;
}

export interface SelectPopupEmptyProps {
    icon?: string;
    text?: ReactNode;
    noResultsText?: (search: string) => ReactNode;
    search: string;
    addAction?: AddAction;
}

const SelectPopupEmpty: FC<SelectPopupEmptyProps> = ({icon, text, noResultsText, search, addAction}) => (
    <css.empty data-cy="selectPopEmpty">
        {icon && <css.emptyIcon style={{backgroundImage: `url("${icon}")`}} />}
        <css.emptyText>
            {search ? (noResultsText?.(search) ?? text) : text}
        </css.emptyText>
        {addAction && (
            <css.emptyAction type="button" onClick={addAction.onClick}>
                {addAction.emptyText ?? addAction.text}
            </css.emptyAction>
        )}
    </css.empty>
);

export default SelectPopupEmpty;
